import { render, staticRenderFns } from "./Main.vue.vue?vue&type=template&id=5ab3aca6&"
import script from "./Main.vue.vue?vue&type=script&lang=js&"
export * from "./Main.vue.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue.vue?vue&type=style&index=0&id=5ab3aca6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports